import { createEvoClient, registerUserInventoryItem } from "@jti/evo-client";
import type { IrsApiContract, RegisterPackCodeResponse } from "@jti/rest-api-types";

import { getUser } from "../../../utils";

const getErrorCode = (error: unknown): string | undefined => {
  if (typeof error !== "object" || error === null || !("error_code" in error)) {
    return undefined;
  }

  const value = (error as { error_code?: unknown }).error_code;
  return typeof value === "string" ? value : undefined;
};

export class IrsApiEvo implements IrsApiContract {
  private readonly client;
  constructor(baseUrl: string, tenantToken: string, recaptchaId: string) {
    const user = getUser();
    this.client = createEvoClient({
      baseUrl,
      tenantToken,
      recaptchaId,
      throwOnError: true,
      ciamToken: user.ciam_token,
    });
  }

  async registerPackCode(code: string): Promise<RegisterPackCodeResponse> {
    try {
      const { data: responseData } = await registerUserInventoryItem({
        client: this.client,
        path: {
          inventory_item_code: code,
        },
        body: {
          product_inventory_type: "sticks",
        },
      });

      const data = responseData?.data;
      const isValid = data?.is_used === true && data?.is_registrable === true;
      const loyalty_rule = data?.product?.loyalty_rule ?? null;

      return {
        hasError: false,
        isValid,
        limitReached: false,
        loyalty_rule,
      };
    } catch (error: unknown) {
      const errorCode = getErrorCode(error);
      const limitReached = errorCode === "inventory.items::register_inventory_item.user_registration_limit_exceeded";

      return {
        hasError: true,
        limitReached,
        isValid: false,
        loyalty_rule: null,
        errorCode,
      };
    }
  }
}
